const WARNINGS = new Set();
export default function warnOnce (msg, ...args) {
  if (WARNINGS.has(msg)) {
    console.warn(msg, ...args);
    WARNINGS.add(msg);
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-debug-utils/warnOnce.js